<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "App"
}
</script>

<style>
/* 非 scoped 样式！覆盖全局滚动行为 */
html, body {
    margin: 0;
    padding: 0;
    /* 核心：允许垂直滚动，移除隐藏属性 */
    overflow-x: hidden; /* 可选：禁止横向滚动 */
    overflow-y: auto;    /* 垂直内容超出时显示滚动条 */
    height: 100%;       /* 可选：确保高度继承 */
}
#app {
    /*font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;*/
    /*color: #2c3e50;*/
    /*margin-top: 20px;*/
    min-height: 100vh;
    overflow: visible;
}
</style>
